/**
 * After a deploy, an open tab can request a lazy chunk that no longer exists.
 * Vite emits `vite:preloadError`; reload once to pick up the new build, and
 * never loop (a sessionStorage stamp guards against a reload storm).
 */
const KEY = 'dd.chunkReloadAt';

export function installChunkReloadGuard() {
  window.addEventListener('vite:preloadError', (event) => {
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < 10_000) return; // already tried; let the error boundary show
    event.preventDefault();
    sessionStorage.setItem(KEY, String(Date.now()));
    window.location.reload();
  });
}
